import { c as _c } from "react/compiler-runtime";
import { useQueryStates } from 'nuqs';
import { useCallback, useMemo } from 'react';
import { breakdownTableFiltersConfig } from '@/modules/finances/lib/breakdown-table-search-params';
import { GRANULARITY_OPTIONS, METRIC_OPTIONS } from '@/modules/finances/types';
function useBreakdownTableFilters() {
  const $ = _c(13);
  const [filters, setFilters] = useQueryStates(breakdownTableFiltersConfig);
  const metrics = filters.bt_metrics;
  const granularity = filters.bt_granularity;
  let t0;
  if ($[0] !== setFilters) {
    t0 = value => {
      setFilters(prev => ({
        ...prev,
        bt_metrics: typeof value === "function" ? value(prev.bt_metrics) : value
      }));
    };
    $[0] = setFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setMetrics = t0;
  let t1;
  if ($[2] !== setFilters) {
    t1 = value_0 => {
      setFilters({
        bt_granularity: value_0
      });
    };
    $[2] = setFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setGranularity = t1;
  let t2;
  if ($[4] !== setFilters) {
    t2 = () => {
      setFilters({
        bt_metrics: [METRIC_OPTIONS.Actuals],
        bt_granularity: GRANULARITY_OPTIONS.Monthly
      });
    };
    $[4] = setFilters;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onReset = t2;
  const isResetDisabled = metrics.length === 1 && metrics[0] === METRIC_OPTIONS.Actuals && granularity === GRANULARITY_OPTIONS.Monthly;
  let t3;
  if ($[6] !== granularity || $[7] !== isResetDisabled || $[8] !== metrics || $[9] !== onReset || $[10] !== setGranularity || $[11] !== setMetrics) {
    t3 = {
      metrics,
      granularity,
      setMetrics,
      setGranularity,
      onReset,
      isResetDisabled
    };
    $[6] = granularity;
    $[7] = isResetDisabled;
    $[8] = metrics;
    $[9] = onReset;
    $[10] = setGranularity;
    $[11] = setMetrics;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export { useBreakdownTableFilters };